import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth';
import offers from './modules/offers';
import cards from './modules/cards';
import loans from './modules/loans';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    errorMessage: ''
  },
  mutations: {
    setSpinnerState(state, value) {
      state.isLoading = value;
    },
    setErrorMessage(state, message) {
      state.errorMessage = message;
    },
    purgeErrorMessage(state) {
      state.errorMessage = '';
    }
  },
  actions: {
    async loading(context, state) {
      await context.commit('setSpinnerState', state);
    },
    async setError(context, message) {
      await context.commit('setErrorMessage', message);
    },
    async purgeError(context) {
      await context.commit('purgeErrorMessage');
    }
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    errorMessage(state) {
      return state.errorMessage;
    }
  },
  modules: {
    auth,
    offers,
    cards,
    loans
  }
})
